import { classes } from "lib/actions/util";
import { PropsWithChildren } from "react";

export default function SidePanel(
  p: PropsWithChildren<{
    className?: string;
  }>,
) {
  return (
    <div
      className={classes(
        "relative flex flex-col",
        "overflow-hidden rounded-xl bg-white shadow-1",
        p.className,
      )}
    >
      {p.children}
    </div>
  );
}
